{
  "version": 1,
  "asset_id": "870533d1-211a-4688-ac99-f57c9a683ce0",
  "project_id": "c2d7b0ea-0bba-49e8-a07e-31dd0f457a9a",
  "url": "/__l5e/assets-v1/870533d1-211a-4688-ac99-f57c9a683ce0/heatmap-scroll-depth.png",
  "r2_key": "a/v1/c2d7b0ea-0bba-49e8-a07e-31dd0f457a9a/870533d1-211a-4688-ac99-f57c9a683ce0/heatmap-scroll-depth.png",
  "original_filename": "heatmap-scroll-depth.png",
  "size": 207544,
  "content_type": "image/png",
  "created_at": "2026-07-21T14:09:04Z"
}
